import React from 'react'

class Logout extends React.Component {
  componentDidMount() {
    this.props.handleLogout(this.props.history)
  }

  render() {
    return (
      <div className="logout">
      </div>
    )
  }
}

export default Logout



// WEBPACK FOOTER //
// ./src/routes/logout/components/Logout.js